import React, { useContext } from "react";
import "./styles.scss";
import { BillingContext } from "contexts/BillingContext";
import { OrgContext } from "contexts/OrgContext";
import agent from "server";
import RedeemableFlow from "./RedeemableFlow";
import { BREV_SUPPORT_EMAIL } from "constants/index";

const RedeemLaunchableCredits: React.FC = () => {
  console.log("Route: /org/:orgId/launchables/redeem");
  const billingContext = useContext(BillingContext);
  const orgContext = useContext(OrgContext);

  const handleRedeem = async () => {
    return await agent.Launchables.redeemLaunchablePoints(
      orgContext.activeOrgId
    );
  };

  return (
    <RedeemableFlow
      title="You earned free GPU credits!"
      description="Congratulations! Your resources are getting used to spin up GPUs which earned you credits."
      redeemableLabel="GPU Credits will be automatically applied to your account"
      redeemableValue={billingContext.launchablePoints}
      redeemFunction={handleRedeem}
      fetchUpdatedData={() => {
        billingContext.fetchBillingProfile();
      }}
      backPath={`/org/${orgContext.activeOrgId}/launchables`}
      backLabel="Go Back"
      successMessage="Credits have been successfully redeemed!"
      errorMessage={`Error redeeming credits. Please try again or contact support at ${BREV_SUPPORT_EMAIL}.`}
    />
  );
};

export default RedeemLaunchableCredits;
